import React from 'react'
import { Calendar, Col, Row } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import moment from 'moment'

const MiniDateCal = styled(Calendar)`
  .ant-picker-content {
    background: white !important;
  }

  .ant-picker-panel {
    background: #fff;
    border: 0;
    border-top: 0px solid #f0f0f0 !important;
    border-radius: 0;
  }

  .ant-picker-body {
    padding: 0px 0 !important;
  }

  td {
    border: 0px !important;
  }

  .ant-picker-cell {
    position: relative;
  }

  .ant-picker-cell-in-view {
    color: #4d566e !important;
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    height: 35px !important;
    width: 35px !important;
    border-radius: 50% !important;
    justify-content: center !important;
    padding-top: 5px !important;
  }

  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: 0px !important;
  }
`

const LeftCol = styled(Col)`
  padding-left: 20px;
`

const CenterCol = styled(Col)`
  text-align: center;
`

const RightArrow = styled(RightOutlined)`
  cursor: pointer;
`

const LeftArrow = styled(LeftOutlined)`
  cursor: pointer;
`

const CalendarContainer = styled(Row)`
  overflow: hidden;
`

const CalenderStyled = ({
  fullscreen = false,
  setSelected,
  drivesList,
  calendarValue = moment(),
  setDate,
  allDate,
  setFromDate,
  fromDate,
  isOccurance = false,
}) => {
  const currentDate = moment()

  const dateCellRender = value => {
    const handleClick = () => {
      const formattedDate = value.format('YYYY-MM-DD')
      setFromDate(formattedDate)
    }

    let cellStyle = {}
    if (value?.isSame(moment(fromDate), 'day')) {
      cellStyle = {
        background: '#3249D7',
        color: 'white',
        borderRadius: '50%',
        padding: '8px',
      }
    } else if (value?.isSame(currentDate, 'day')) {
      cellStyle = {
        border: '1px solid #3249D7',
        color: '#3249D7',
        borderRadius: '50%',
        padding: '8px',
      }
    } else if (allDate?.some(date => value?.isSame(date?.date, 'day'))) {
      if (value?.isBefore(currentDate, 'day')) {
        cellStyle = {
          background: '#DCE0F6',
          color: '#3249D7',
          borderRadius: '50%',
          padding: '8px',
        }
      } else if (value?.isAfter(currentDate, 'day')) {
        cellStyle = {
          border: '1px solid #3249D7',
          color: '#3249D7',
          borderRadius: '50%',
          padding: '8px',
        }
      }
    }

    return (
      <div
        style={cellStyle}
        onClick={handleClick}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
      >
        {value.date()}
      </div>
    )
  }

  const onPanelChange = (value, mode) => {
    if (mode === 'date') {
      setDate(value)
    }
  }

  return (
    <CalendarContainer id="calendarDiv">
      <Col span={24}>
        <MiniDateCal
          getPopupContainer={() => document.getElementById('calendarDiv')}
          fullscreen={fullscreen}
          dateFullCellRender={dateCellRender}
          onPanelChange={onPanelChange}
          headerRender={({ value = calendarValue, onChange }) => {
            const month = value.month()
            const year = value.year()

            return (
              <div>
                <Row
                  type="flex"
                  justify="space-between"
                  style={{ background: 'white' }}
                >
                  <LeftCol span={4}>
                    <LeftArrow
                      onClick={() => {
                        const newValue = value.clone()
                        newValue.month(month - 1)
                        onChange(newValue)
                      }}
                    />
                  </LeftCol>
                  <CenterCol span={16}>
                    <b>{`${value.format('MMMM')}, ${year}`}</b>
                    <p />
                  </CenterCol>
                  <Col span={4}>
                    <RightArrow
                      onClick={() => {
                        const newValue = value.clone()
                        newValue.month(month + 1)
                        onChange(newValue)
                      }}
                    />
                  </Col>
                </Row>
              </div>
            )
          }}
        />
      </Col>
    </CalendarContainer>
  )
}

export default CalenderStyled
